import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 0,
  class: "flex flex-col items-center w-full mx-auto mt-28"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", {
  style: {"font-size":"10rem"},
  class: "material-icons-outlined opacity-10"
}, " bookmark ", -1)
const _hoisted_4 = { class: "opacity-40" }
const _hoisted_5 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FullExercise = _resolveComponent("FullExercise")!
  const _component_ExerciseSolutionContainer = _resolveComponent("ExerciseSolutionContainer")!
  const _component_SlotSkeleton = _resolveComponent("SlotSkeleton")!
  const _component_Spinner = _resolveComponent("Spinner")!
  const _component_VueEternalLoading = _resolveComponent("VueEternalLoading")!

  return (_openBlock(), _createElementBlock("div", null, [
    (!_ctx.firstLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mainStore.exercises, (exercise) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "mb-14",
              key: 'e-' + exercise.id
            }, [
              _createVNode(_component_FullExercise, { exercise: exercise }, null, 8, ["exercise"]),
              (!_ctx.loadingSolutionsByExercise[exercise.id])
                ? (_openBlock(), _createBlock(_component_ExerciseSolutionContainer, {
                    key: 0,
                    class: "mt-4",
                    showTitle: false,
                    forceShowAll: true,
                    exercise: exercise,
                    solutions: _ctx.mainStore.getPaginatedSolutionsByExerciseId(exercise.id).data,
                    allowAddSolution: false,
                    showExerciseThreadLink: true
                  }, null, 8, ["exercise", "solutions"]))
                : (_openBlock(), _createBlock(_component_SlotSkeleton, { key: 1 }))
            ]))
          }), 128)),
          (_ctx.mainStore.exercises.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _hoisted_3,
                _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.$t("misc.no_favorites")), 1)
              ]))
            : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createVNode(_component_SlotSkeleton),
          _createVNode(_component_SlotSkeleton),
          _createVNode(_component_SlotSkeleton),
          _createVNode(_component_SlotSkeleton)
        ])),
    _createVNode(_component_VueEternalLoading, {
      load: _ctx.onLoadMore,
      "is-initial": _ctx.isInitialInfiniteLoad,
      "onUpdate:is-initial": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isInitialInfiniteLoad) = $event))
    }, {
      loading: _withCtx(() => [
        _createVNode(_component_Spinner)
      ]),
      "no-more": _withCtx(() => [
        _createTextVNode("   ")
      ]),
      _: 1
    }, 8, ["load", "is-initial"])
  ]))
}